var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white--text",attrs:{"color":"green","small":""},on:{"click":_vm.copyFileUrl}},[_vm._v(" "+_vm._s(_vm._f("t")('action.copy_link'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }